import { LoginIcon } from '../../Brand/Icon';
import React from "react";
import { APP_ROUTES } from '../../../utils/constant';
import url from '../../../utils/url';
import { getUser } from '../../../utils/func';
import UserImage from '../../UserImage';
import { AnimatedLink } from '../AnimatedLink';
import { useTranslation } from 'react-i18next';

export default function ButtonLoginOrProfile() {
	const { t } = useTranslation();
	let from = window.location.pathname;
	let user = getUser();
	return (
		<span>
			{user === null ?
				(<AnimatedLink aria-label={t('login.title')} to={url(`${APP_ROUTES.LOGIN}?from=${from}`)}><LoginIcon className="nav-icon" /></AnimatedLink>)
				:
				(<AnimatedLink aria-label={t('user.account')} to={url(`${APP_ROUTES.USER}/${user.user_name}`)}><UserImage picture={user.picture} loading="eager" /></AnimatedLink>)
			}
		</span>
	)
}
